<template>
  <ConfigurationStationTemplate
    :endPointData="endPointData"
    :textData="textData"
  />
</template>
<script setup>
import { computed } from 'vue';

// Utils
import { useRoute } from 'vue-router';
import generateTextData from '@/functions/generate_text_data';

// Components
import ConfigurationStationTemplate from '@/components/generic/configuration_station_template.vue';

const route = useRoute();

const endPointData = {
  newFormRoute: 'newShaftV2StationForm',
  operationType: 'station',
  endpointIdentifier: 'stations',
  stationGroupsEndpoint: `/organisations/${route.params.organisationId}/shafts_v2/shafts/${route.params.shaftId}/stations`,
  nav: 'shafts.configuration.stations.nav',
};

const mainKey = 'shafts.configuration.stations';
const textDataArray = [
  'search',
  'new',
];

const textData = computed(() => {
  return generateTextData(mainKey, textDataArray);
});
</script>
